<template lang="html">

  <div class="ajusa--view ajusa">

    <section class="vh intro">
      <a href="#" v-scroll-to="'.menu-nosotros'" class="scrolldown"></a>
      <div class="col-50 flex column justify-center align-center animated fadeInLeft">
        <div class="container-text">
          <h2 class="title title-52" v-html="$t('Ajusath.titulo')"></h2>
          <p v-html="$t('Ajusath.entradilla')"></p>
        </div>
      </div>
      
    </section>


    <section>
      <ul class="menu-nosotros flex row"> 
        <li class="flex column justify-center" v-scroll-to="'#aj-servicios'" ><a v-html="$t('Ajusath.vanguardia.title')" href="#"></a></li>
        <li class="flex column justify-center" v-scroll-to="'#aj-compromiso'"><a v-html="$t('Ajusath.tecnologia.title')" href="#"></a></li>
        <li class="flex column justify-center" v-scroll-to="'#aj-catalogo'"><a v-html="$t('Ajusath.desarrollo.title')" href="#"></a></li>
        <li class="flex column justify-center" v-scroll-to="'#aj-equipo'"><a v-html="$t('Ajusath.sostenibilidad.title')" href="#"></a></li>
        
      </ul>
    </section>




    <section id="aj-servicios" class="sec-ajusa">
      <div class="flex wrap">
        <article class="img-aj col-75  waypoints" data="fadeInUp">
        </article>
        <article class="container-text col-20 waypoints" data="fadeInRight">
          <h3 v-html="$t('Ajusath.vanguardia.title')" class="title title-72"></h3>
          <p v-html="$t('Ajusath.vanguardia.description')"></p>
        </article>
      </div>
    </section>

    <section id="aj-compromiso" class="sec-ajusa">
      <div class="flex wrap row-reverse">
        <article class="img-aj col-75 waypoints" data="fadeInUp">
        </article>
        <article class="container-text col-20 waypoints" data="fadeInLeft">
          <h3 class="title title-72"  v-html="$t('Ajusath.tecnologia.title')"></h3>
          <p  v-html="$t('Ajusath.tecnologia.description')"></p>

        </article>
      </div>
    </section>
    <section id="aj-catalogo" class="sec-ajusa">
      <div class="flex wrap">
        <article class="img-aj col-75 waypoints" data="fadeInUp">
        </article>
        <article class="col-25">
          <div class="flex wrap pad-sec text-ajusa waypoints" data="fadeInUp">
            <article class="col-100 flex row justify-end waypoints" data="fadeInLeft">
              <h3 class="title title-72"  v-html="$t('Ajusath.desarrollo.title')"></h3>
            </article>
            <article class="container-text col-100 flex row justify-start waypoints" data="fadeInRight">
              <p  v-html="$t('Ajusath.desarrollo.description')"></p>
            </article>
          </div>    
        </article>
      </div>
      
    </section>
    <section id="aj-equipo" class="sec-ajusa">
      <div class="flex row-reverse wrap">
        <article class="img-aj col-75 waypoints" data="fadeInUp">
        </article>
        <article class="container-text col-20 waypoints" data="fadeInLeft">
          <h3 class="title title-72"  v-html="$t('Ajusath.sostenibilidad.title')"></h3>
          <p  v-html="$t('Ajusath.sostenibilidad.description')"></p>
        </article>
      </div>

    </section>

    <section class="sec-center pad-sec">
      <div class="container waypoints" data="fadeInUp">
        <h6 class="title title-36"  v-html="$t('Ajusath.nuestra_energia')"></h6>

        <router-link :to="$t('Ajusath.boton_consciencia.descarga')" target="_blank" class="btn btn-dark" v-html="$t('Ajusath.boton_consciencia.nombre')"></router-link>
      </div>
    </section>


    
    <otras-secciones :data="['productos','tecnologia']"></otras-secciones>


  </div>

</template>

<script lang="js">

  import Otras_Secciones from '@/components/parts/acceso-a-secciones';

  export default  {
    name: 'ajusa',
    props: [],
    mounted() {
      $(window).scroll(function(event) {

        var distancia = $(window).scrollTop();
        var altura = $(window).height();

        if(distancia >= altura - 89){
          $(".menu-nosotros").addClass('fixed');
          $(".menu-catalogo-h").addClass('show');
          $(".solicitar-cat").addClass('show');
          $("#aj-servicios").css("padding-top", "300px");
        }else{
          $(".menu-nosotros").removeClass('fixed');
          $(".menu-catalogo-h").removeClass('show');
          $(".solicitar-cat").removeClass('show');
          $("#aj-servicios").css("padding-top", "180px");
        }
      });
    },
    data() {
      return {

      }
    },
    methods: {

    },
    components: {
      'otras-secciones' : Otras_Secciones,
    }
  }
</script>

<style scoped>
.btn-dark {
  margin-top: 20px;
}
.intro .col-50{
 background: rgba(5,66,121,0.9);
    position: absolute;
    z-index: 5;
}
.title-72{
  font-size: 72px;
  line-height: 80px;
  margin: 48px 0 42px;
  transform: translateX(-176px);
  font-weight: bold;
}
@media only screen and (max-width: 1450px) {
  .intro .col-50{
    width: calc(100% - 70%);
    left: 40px;
  }
}
@media only screen and (max-width: 1366px){
  .intro .col-50 {
    width: 50%;
    left: 0;
    background: rgba(5,66,121,.9);
  }
}

@media only screen and (max-width: 800px) {
  .title-72{
    font-size: 45px;
    margin:62px 0 42px;
  }
}
@media only screen and (max-width: 500px){
  .intro .col-50{
    width: 100%;
  }
  .sec-ajusa .title-72{
    font-size: 36px;
    margin-top: 0;
  }
  .title-72, 
  #aj-equipo p{
    transform: translateX(0);
  }
}
@media only screen and (max-width: 350px) {

  .title{
    font-size: 32px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/ajusa-th.vue